import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);
import axios from 'axios';

import dashboard from './modules/Dashboard';
import discovery from './modules/Discovery';
import domains from './modules/Domains';
import archive from './modules/Archive';
import userInfo from './modules/UserInfo';
import preferences from './modules/Preferences';
import notifications from './modules/Notifications';

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    dashboard,
    discovery,
    archive,
    userInfo,
    preferences,
    domains,
    notifications
  },
  state: {
    inboxEntrySize: 20,
    sentEntrySize: 20,
    spamEntrySize: 20,
    emailSearchEntrySize: 20,
    isNotificationDrawerOpen: false,
    userInformation: null,
    allPermissions: [],
    subscriptionPermissions: [],
    allOrgFlattened: [],
    selectedTheme: null,
    addWidget: null,
    domain: null,
    title: null,
    selectedRow: [],
    emailCount: '',
    refCount: 0,
    isLoading: false,
    activeConnectors: [],
    currentOrgActiveConnectors: [],
    addWidgetId: null,
    sessionId: null,
    orgId: null,
    currentlySelectedOrgId: null,
    orgName: null,
    orgData: null,
    currentOrgData: null,
    kpiDetails: null,
    singleSignOnStatus: null,
    timeUnit: null,
    addWidgetCalled: null,
    timezone: null,
    widgetId: null,
    kpiId: null,
    size: null,
    widgetTypeName: null,
    globalNav: [],
    onboardingStatus: 'ONBOARDED',
    axiosSource: axios.CancelToken.source(),
    isCurrentOrgLegacy: false,
    subscriptions: {},
    connectorList: [],
    currentSubscription: {}
  },
  mutations: {
    setNotificationDrawer(state, isOpen) {
      state.isNotificationDrawerOpen = isOpen;
    },

    loading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setAllOrgFlattened(state, orgs) {
      state.allOrgFlattened = orgs;
    },
    setSelectedTheme(state, themeName) {
      state.selectedTheme = themeName;
    },
    setSelectedOrg(store, orgId) {
      store.currentlySelectedOrgId = orgId;
    },
    setAllPermissions(state, allPermissions) {
      state.allPermissions = allPermissions;
    },
    setSubscriptionPermissions(state, subscriptionPermissions) {
      state.subscriptionPermissions = subscriptionPermissions;
    },
    setActiveConnectors(state, activeConnectors) {
      state.activeConnectors = activeConnectors;
    },
    setCurrentOrgActiveConnectors(state, currentOrgActiveConnectors) {
      state.currentOrgActiveConnectors = currentOrgActiveConnectors;
    },
    setSingleSignOnStatus(state, status) {
      state.singleSignOnStatus = status;
    },
    setCurrentTimeZone(state, timezone) {
      state.timezone = timezone;
    },
    setUserInfo(state, user) {
      state.userInformation = user;
    },
    setCustomer(state, customer) {
      state.customer = customer;
    },
    setSubscriptions(state, subscriptions) {
      state.subscriptions = subscriptions;
    },
    setCurrentSubscription(state, currentSubscription) {
      state.currentSubscription = currentSubscription;
    },
    setDefaultPaymentProfile(state, profileId) {
      state.subscriptions.paymentMode.id = profileId;
    },
    setGlobalNav(state, globalNav) {
      state.globalNav = globalNav;
    },
    setOnboardingStatus(state, onboardingStatus) {
      state.onboardingStatus = onboardingStatus;
    },
    setOrgData(state, orgData) {
      state.orgData = orgData;
    },
    setAxiosSource(state) {
      state.axiosSource.cancel('Landing Component got unmounted');
      state.axiosSource = axios.CancelToken.source();
    },
    setIsCurrentOrgLegacy(state, isLegacyOrg) {
      state.isCurrentOrgLegacy = isLegacyOrg;
    },
    setCurrentOrgData(state, currentOrgData) {
      state.currentOrgData = currentOrgData;
    },
    setConnectorList(state, connectorList) {
      state.connectorList = connectorList;
    }
  },
  getters: {
    selectedCheck: state => {
      return state.selectedRow;
    },
    selectedCount: state => {
      return state.emailCount;
    },
    connectorList: state => state.connectorList
  },
  actions: {
    SET_SUBSCRIPTIONS({ commit }, payload) {
      commit('setSubscriptions', payload);
    },
    SET_CONNECTORS_SOURCE_DETAILS({ commit }, payload) {
      commit('setConnectorList', payload);
    },
    SET_CURRENT_SUBSCRIPTION({ commit }, payload) {
      commit('setCurrentSubscription', payload);
    }
  }
});
